import React, { useState, useEffect } from 'react'
import intl from 'react-intl-universal'
import { MailFill, ClockCircleOutline } from 'antd-mobile-icons'
import { Skeleton, Grid, Collapse } from 'antd-mobile'
import ButtonTool from '../../result/ButtonTool'
import dayjs from 'dayjs'

import CurrencySymbol from '../../../components/CurrencySymbol'
import AutoImage from '../../../components/AutoImage'
import Header from '../../../components/Header'
import SexLabel from '../../../components/SexLabel'
import OrderStatus from '../OrderStatus'
import { getOrderDetailModel } from '../../../model/store'
import { formatJSON, getUrlParam, replaceCDNDomain } from '../../../utils'
import math, { formatNumber } from '../../../utils/math'
import CouponBox from '../CouponBox'

import HouseIcon from '../../../components/Icon/HouseIcon'
import CalendarIcon from '../../../components/Icon/CalendarIcon'
import PeopleIcon from '../../../components/Icon/PeopleIcon'
import ServeIcon from '../../../components/Icon/ServeIcon'
import DatabaseIcon from '../../../components/Icon/DatabaseIcon'
import CartFillIcon from '../../../components/Icon/CartFillIcon'
import CouponIcon from '../../../components/Icon/CouponIcon'
import OrderProductBenefitPrice from '../../../components/OrderProductBenefitPrice'

import './index.less'
import { getLanguageStore } from '../../../utils/storage/language'
import { addBehaviorsRecord } from '../../../utils/BehaviorstatsHelp'

const FORMAT = 'D MMMM'
const ProductRemark = ({ product }) => {
    const { extendColumn2 } = product
    if (extendColumn2) {
        const obj = formatJSON(extendColumn2) || {}
        const { remark } = obj || {}
        if (remark) {
            return <div className='text-gray'><small>{remark}</small></div>
        }
    }
    return null
}
export default function OrderDetail({ orderId, needHeader = true, callback, title }) {
    const [loading, setLoading] = useState(false)
    const [orderDetail, setOrderDetail] = useState(null)
    const [extendData, setExtendData] = useState(null)

    orderId = getUrlParam('id') || orderId
    const lanKey = getLanguageStore()

    const judgeShowBookingInfo = ({ extendData = {}, bookingData = {}, orderDetail = {} }) => {
        const extendFlag = extendData.electronicSignature || extendData.adultNum || extendData.childrenNum || extendData.dinersNum
        const bookingFlag = bookingData.payMethod || bookingData.hotelName || bookingData.roomNo || bookingData.address || Object.keys(bookingData.otherObj || {}).length > 0
        const detailFlag = orderDetail.firstName || orderDetail.lastName || orderDetail.email || orderDetail.phoneNumber || orderDetail.remark || orderDetail.roomNo
        return extendFlag || bookingFlag || detailFlag
    }

    useEffect(() => {
        if (orderId) {
            const renderOrderDetail = () => {
                setLoading(true)
                getOrderDetailModel({ orderId }).then(res => {
                    const { extendColumn } = res
                    setExtendData(formatJSON(extendColumn) || {})
                    setOrderDetail(res)
                    setLoading(false)

                    addBehaviorsRecord({
                        behaviorType: 160200,
                        behavior: 160218,
                        storeId: res.storeId,
                        value1: orderId,
                    })
                }).catch(() => {
                    setLoading(false)
                })
            }
            renderOrderDetail()
        }
    }, [orderId])

    const getBookingData = () => {
        const { bookDate, bookTime, people, payMethod, hotelName, otherObj,address } = extendData || {}

        return {
            bookDate,
            bookTime,
            people,
            payMethod,
            hotelName,
            otherObj,
            address
        }
    }

    const getBookNotice = () => {
        const { products, bookingResultReminderMessage } = orderDetail || {}
        const arr = products.filter(item => item.bookingResultReminderMessage !== '').map(item => item.bookingResultReminderMessage)
        if (arr.length > 0) {
            //去重arr
            const uniqueArr = [...new Set(arr)]
            return <>
                <hr />
                {uniqueArr.join('\n')}
            </>
        }
        return bookingResultReminderMessage || ''
    }

    console.log(needHeader, '/////needHeader//////')

    const { products, currencyCode, serviceFee, taxFee, totalPrice, serviceRate, taxRate, storeName, orderTime, serviceFeeType ,taxType, thirdPartyPreviewCalculate } = orderDetail || {}
    const hideFeeRate = thirdPartyPreviewCalculate === true
    const orderPackage = orderDetail?.orderPackage
    const hasOrderPackage = !!(orderPackage && (
        typeof orderPackage === 'string'
            ? orderPackage.trim()
            : Object.keys(orderPackage).length > 0
    ))
    const orderPackageName = typeof orderPackage === 'string'
        ? orderPackage
        : (orderPackage?.packageName || orderPackage?.name || '')
    const bookingData = getBookingData()

    const pageHashOverHidden = document.querySelector('.adm-overflow-hidden')
    let isOverflowHidden = false
    if (pageHashOverHidden) {
        isOverflowHidden = true
    }
    return (
        <div
            className='art-od-wrapper bg-white'
            style={isOverflowHidden ? { overflowY: 'auto', height: '100vh' } : {}}
        >
            {
                needHeader && <Header title={title || intl.get('order_detail').d('订单详情')} callback={callback} />
            }
            {
                !loading && orderDetail ?
                    <article className='od-main'>
                        <OrderStatus status={orderDetail.status} time={orderDetail.operateTime} showIconCard={true} />
                        {
                            orderDetail.status === 2 && (
                                <ButtonTool
                                    item={orderDetail}
                                />
                            )
                        }

                        <div className='p10'>
                            {
                                products && products.length > 0 && (
                                    <div className='bk-pd-box'>

                                        <ul className='bk-list-wrapper'>
                                            <li className='jm-flex'>
                                                <div className='bk-left'>
                                                    <MailFill width={23} height={23} color='var(--adm-color-primary)' />
                                                </div>
                                                <div className='bk-right jm-flex-item'>
                                                    <label>{intl.get('orderNumber').d('订单号')}</label>
                                                    <div className='bk-txt'>
                                                        {orderId}
                                                        <div style={{ color: '#999' }}><small>{dayjs(orderTime).format('YYYY-MM-DD HH:mm:ss')}</small></div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className='jm-flex'>
                                                <div className='bk-left'>
                                                    <HouseIcon width={23} height={23} color='var(--adm-color-primary)' />
                                                </div>
                                                <div className='bk-right jm-flex-item'>
                                                    <label>{intl.get('h_merchant').d('Merchant')}</label>
                                                    <div className='bk-txt'>{storeName}</div>
                                                </div>
                                            </li>
                                            {
                                                bookingData.bookDate && (
                                                    <li className='jm-flex'>
                                                        <div className='bk-left'>
                                                            <CalendarIcon width={24} height={24} color='var(--adm-color-primary)' />
                                                        </div>
                                                        <div className='bk-right jm-flex-item'>
                                                            <label>{intl.get('h_date').d('Date')}</label>
                                                            <div className='bk-txt'>{bookingData.bookDate}</div>
                                                        </div>
                                                    </li>
                                                )
                                            }
                                            {
                                                bookingData.people && (
                                                    <li className='jm-flex'>
                                                        <div className='bk-left'>
                                                            <PeopleIcon width={24} height={24} color='var(--adm-color-primary)' />
                                                        </div>
                                                        <div className='bk-right jm-flex-item'>
                                                            <label>{intl.get('person_num').d('Number of people')}</label>
                                                            <div className='bk-txt'>{bookingData.people}</div>
                                                        </div>
                                                    </li>
                                                )
                                            }
                                            {
                                                bookingData.bookTime && (
                                                    <li className='jm-flex'>
                                                        <div className='bk-left'>
                                                            <CalendarIcon width={24} height={24} color='var(--adm-color-primary)' />
                                                        </div>
                                                        <div className='bk-right jm-flex-item'>
                                                            <label>{intl.get('h_time').d('Time')}</label>
                                                            <div className='bk-txt'>{bookingData.bookTime}</div>
                                                        </div>
                                                    </li>
                                                )
                                            }
                                            <li className='jm-flex'>
                                                <div className='bk-left'>
                                                    <CartFillIcon width={24} height={24} color='var(--adm-color-primary)' />
                                                </div>
                                                <div className='bk-right jm-flex-item'>
                                                    <label>{intl.get('app_items').d('Items')}</label>
                                                    <div className='bk-product-list'>
                                                        <div>
                                                            {products.map((item, index) => (
                                                                <div className={`bk-product-item jm-flex`} key={index}>
                                                                    <div className='jm-flex-item m-r-sm'>
                                                                        {item.productName} * {item.num || 1}
                                                                        {item.extendColumn1 && item.extendColumn1 === 'couponUsedProduct' ? <small style={{ color: 'red' }}>[GIFT]</small> : null}
                                                                        <div className='bk-product-attr'>
                                                                            {item.productExtraName && (
                                                                                <div className='text-gray'>
                                                                                    <small>{item.productExtraName}</small>
                                                                                </div>
                                                                            )}
                                                                            {item.productExtraAttrSubKeyValues?.map((attr, index) => (
                                                                                <div className='text-gray' key={index}>
                                                                                    <small>{attr.parentName} - {attr.name}*{attr.num}</small>
                                                                                </div>
                                                                            ))}
                                                                            <ProductRemark product={item} />
                                                                        </div>
                                                                        <div>
                                                                            {
                                                                                item.serviceFee > 0 && (
                                                                                    <div className='text-gray'>
                                                                                        <small>
                                                                                            {intl.get('fees').d('服务费')}
                                                                                            {
                                                                                                !hideFeeRate && item.serviceRate > 0 ?
                                                                                                    <>
                                                                                                        ({math.mul(item.serviceRate, 100)}%)
                                                                                                    </> : null
                                                                                            }
                                                                                            &nbsp;&nbsp;
                                                                                            <CurrencySymbol currency={currencyCode} />{formatNumber(item.serviceFee)}
                                                                                        </small>
                                                                                    </div>
                                                                                )
                                                                            }
                                                                            {
                                                                                item.taxFee > 0 && (
                                                                                    <div className='text-gray'>
                                                                                        <small>
                                                                                            {intl.get('taxes').d('税费')}
                                                                                            {
                                                                                                !hideFeeRate && item.taxRate > 0 ?
                                                                                                    <>
                                                                                                        ({math.mul(item.taxRate, 100)}%)
                                                                                                    </> : null
                                                                                            }
                                                                                            &nbsp;&nbsp;
                                                                                            <CurrencySymbol currency={currencyCode} />{formatNumber(item.taxFee)}
                                                                                        </small>
                                                                                    </div>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <OrderProductBenefitPrice product={item} currencyCode={currencyCode} />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className='jm-flex' style={{ alignItems: 'flex-start' }}>
                                                <div className='bk-left'>
                                                    <DatabaseIcon width={24} height={24} color='var(--adm-color-primary)' />
                                                </div>
                                                <div className='bk-right jm-flex-item'>

                                                    <article className='bk-price-list'>
                                                        <section className='jm-flex hide'>
                                                            <div className='jm-flex-item'>{intl.get('price').d('Price')}</div>
                                                            <div className='jm-price'><CurrencySymbol currency={currencyCode} />{formatNumber(orderDetail.price)}</div>
                                                        </section>
                                                        {
                                                            serviceFee > 0 && (
                                                                <section className={` jm-flex`}>
                                                                    <div className='jm-flex-item'>
                                                                        {intl.get('fees').d('服务费')}
                                                                        {
                                                                            !hideFeeRate && serviceRate > 0 && serviceFeeType !==4 ?
                                                                                <>
                                                                                    ({math.mul(serviceRate, 100)}%)
                                                                                </> : null
                                                                        }
                                                                        </div>
                                                                    <div className='jm-price'><CurrencySymbol currency={currencyCode} />{formatNumber(serviceFee)}</div>
                                                                </section>
                                                            )
                                                        }
                                                        {
                                                            taxFee > 0 && (
                                                                <section className={` jm-flex`}>
                                                                    <div className='jm-flex-item'>{intl.get('taxes').d('税费')}
                                                                        {
                                                                            !hideFeeRate && taxRate > 0 && taxType !== 4 ?
                                                                                <>
                                                                                    ({math.mul(taxRate, 100)}%)
                                                                                </> : null
                                                                        }
                                                                    </div>
                                                                    <div className='jm-price'><CurrencySymbol currency={currencyCode} />{formatNumber(taxFee)}</div>
                                                                </section>
                                                            )
                                                        }
                                                        {
                                                            hasOrderPackage ? (
                                                                <section className='jm-flex'>
                                                                    <div className='jm-flex-item'>{intl.get('od_benefit_package').d('权益包')}</div>
                                                                    <div className='jm-price text-right' style={{ width: '70%' }}>{orderPackageName}</div>
                                                                </section>
                                                            ) : (
                                                                <>
                                                                    {
                                                                        orderDetail.orderUsedCoupon && (
                                                                            <section className={` jm-flex`}>
                                                                                <div className='jm-flex-item'>{intl.get('od_coupon').d('优惠券')}</div>
                                                                                <div className='jm-price text-right' style={{ width: '70%' }}>{orderDetail.orderUsedCoupon.couponName}</div>
                                                                            </section>
                                                                        )
                                                                    }
                                                                    {
                                                                        orderDetail.couponDiscountPrice > 0 && (
                                                                            <section className={` jm-flex`}>
                                                                                <div className='jm-flex-item'>{intl.get('od_discount_price').d('优惠金额')}</div>
                                                                                <div className='jm-price'>-<CurrencySymbol currency={currencyCode} />{formatNumber(orderDetail.couponDiscountPrice)}</div>
                                                                            </section>
                                                                        )
                                                                    }
                                                                </>
                                                            )
                                                        }
                                                        <section className='jm-flex clear-bg'>
                                                            <div className='jm-flex-item'>{intl.get('total').d('Total')}</div>
                                                            <div className='jm-price'><CurrencySymbol currency={currencyCode} />{formatNumber(totalPrice)}</div>
                                                        </section>
                                                    </article>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </div>
                        {
                            judgeShowBookingInfo({ extendData, bookingData, orderDetail }) && (
                                <div style={{ fontWeight: '500', padding: '0 10px', marginTop: 10 }}>
                                    <div className='bk-info-box'>

                                        <Grid className="content" columns={4} gap={15}>
                                            {
                                                bookingData.payMethod && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('pay_method').d('Pay by')}: </Grid.Item>
                                                        <Grid.Item span={3}>
                                                            {bookingData.payMethod[lanKey] || bookingData.payMethod['en_US'] || bookingData.payMethod['zh_CN']}
                                                        </Grid.Item>
                                                    </>
                                                )
                                            }

                                            {
                                                orderDetail?.orderPay?.id && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('pay_order_id').d('支付订单号')}: </Grid.Item>
                                                        <Grid.Item span={3}>{orderDetail.orderPay.id}</Grid.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                orderDetail?.orderPay?.payTime && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('pay_time').d('支付时间')}: </Grid.Item>
                                                        <Grid.Item span={3}>{dayjs(orderDetail.orderPay.payTime).format('YYYY-MM-DD HH:mm:ss')}</Grid.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                bookingData.hotelName && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('hotel_name').d('酒店名称')}: </Grid.Item>
                                                        <Grid.Item span={3}>{bookingData.hotelName}</Grid.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                orderDetail.roomNo && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('room_no').d('Room No.')}: </Grid.Item>
                                                        <Grid.Item span={3}>{orderDetail.roomNo}</Grid.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                bookingData.otherObj && Object.keys(bookingData.otherObj).length > 0 && (
                                                    <>
                                                        {
                                                            Object.keys(bookingData.otherObj).map(item => (
                                                                <>
                                                                    <Grid.Item className='label-gray' key={item}>{bookingData.otherObj[item].title}: </Grid.Item>
                                                                    <Grid.Item span={3}>{bookingData.otherObj[item].value}</Grid.Item>
                                                                </>
                                                            ))
                                                        }
                                                    </>
                                                )
                                            }
                                            {
                                                orderDetail.firstName && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('first_name').d('名字')}: </Grid.Item>
                                                        <Grid.Item span={3}>
                                                            <SexLabel value={extendData.sex} />
                                                            {orderDetail.firstName}
                                                        </Grid.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                orderDetail.lastName && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('last_name').d('姓氏')}: </Grid.Item>
                                                        <Grid.Item span={3}>
                                                            {/* <SexLabel value={extendData.sex} /> */}
                                                            {orderDetail.lastName}
                                                        </Grid.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                orderDetail.email && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('email').d('邮箱')}:</Grid.Item>
                                                        <Grid.Item span={3}>{orderDetail.email}</Grid.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                orderDetail.phoneNumber && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('phone').d('电话')}:</Grid.Item>
                                                        <Grid.Item span={3}>{orderDetail.phoneNumber}</Grid.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                orderDetail.remark && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('additional_remark').d('其他要求')}:</Grid.Item>
                                                        <Grid.Item span={3}>{orderDetail.remark}</Grid.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                extendData.electronicSignature && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('ele_signature').d('电子签名')}:</Grid.Item>
                                                        <Grid.Item span={3}><img style={{ width: '100%' }} src={replaceCDNDomain(extendData.electronicSignature)} alt="signature" /></Grid.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                (extendData.adultNum || extendData.childrenNum || extendData.dinersNum) && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('diners_num').d('宾客人数')}:</Grid.Item>
                                                        <Grid.Item span={3}>
                                                            {extendData.adultNum || extendData.childrenNum
                                                                ? `${intl.get('adult').d('成人')}: ${extendData.adultNum || 0}，${intl.get('children').d('儿童')}: ${extendData.childrenNum || 0}`
                                                                : extendData.dinersNum}
                                                        </Grid.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                orderDetail.startTime && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('expected_time_of_delivery').d('Expected time of delivery')}:</Grid.Item>
                                                        <Grid.Item span={3}>{dayjs(new Date(orderDetail.startTime)).format('YYYY-MM-DD HH:mm:ss')}</Grid.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                extendData.whatsAppId && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('whatsAppId').d('WhatsApp ID')}:</Grid.Item>
                                                        <Grid.Item span={3}>{extendData.whatsAppId}</Grid.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                extendData.roomDayPassUnitNo && (
                                                    <>
                                                        <Grid.Item className='label-gray' style={{ wordWrap: 'break-word' }}>Room/Daypass/Unit No.:</Grid.Item>
                                                        <Grid.Item span={3}>{extendData.roomDayPassUnitNo}</Grid.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                bookingData.address && (
                                                    <>
                                                        <Grid.Item className='label-gray'>{intl.get('address').d('Address')}:</Grid.Item>
                                                        <Grid.Item span={3}>{bookingData.address}</Grid.Item>
                                                    </>
                                                )
                                            }
                                        </Grid>
                                    </div>
                                </div>
                            )
                        }

                        {
                            orderDetail.orderUsedCoupons && orderDetail.orderUsedCoupons.length > 0 && (
                                <div className='p10'>
                                    <CouponBox
                                        list={orderDetail.orderUsedCoupons}
                                        products={products}
                                        showNumber={true}
                                    />
                                </div>
                            )
                        }


                        <div className='p10  m-t-sm ' style={{ fontWeight: '500' }}>
                            <div style={{ whiteSpace: 'pre-wrap' }}>{getBookNotice()}</div>
                        </div>
                    </article>
                    :
                    <>
                        <Skeleton.Title active animated />
                        <Skeleton.Paragraph lineCount={3} active animated />
                    </>
            }
        </div>
    )
}
